const getGradient = name => theme => theme.vars.palette.gradients[name];

const gradients = {
  grey: getGradient('grey'),
  blue: getGradient('blue'),
  indigo: getGradient('indigo'),
  green: getGradient('green'),
  orange: getGradient('orange'),
  red: getGradient('red'),
};

export default gradients;
